export default __webpack_public_path__ + "static/media/green-tick-trans-bg.9eac09b2.png";